<div class="popup">
  <div class="pp-title">
    <span>Selecione o filtro</span>
  </div>
  <ul>
    <li [ngClass]="{'disabled': checkFilter(filter)}" *ngFor="let filter of filterOptions" (click)="addFilter(filter)">{{filter.tableName}}</li>
  </ul>
</div>